module.exports = __webpack_public_path__ + "static/media/facebook.e44d4dd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/facebook.svg
// module id = 1219
// module chunks = 0